module.exports = __webpack_public_path__ + "static/media/info-light.8e3a283f.svg";